module.exports = __webpack_public_path__ + "img/imperial-verde.63175b28.png";